import React from 'react'
import { useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import HeroClientes from '../Components/HeroClientes';
import Companies2 from '../Components/Companies2';

const Clientes = () => {
    useEffect(() => {
        const loadLocomotiveScroll = async () => {
            const LocomotiveScroll = (await import("locomotive-scroll")).default;
            new LocomotiveScroll();
        };
    
        loadLocomotiveScroll();
    }, []);
    return (
        <div className="h-full overflow-x-hidden">
            <Header />
            <HeroClientes />
            <Companies2 />
            <Footer />
        </div>
    )
}

export default Clientes